import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/components/spinner/spinner.service';
import { FormControl, FormGroup } from '@angular/forms';
import { LogsService } from '@services/logs/logs.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
  providers: [DatePipe] // Proveedor de DatePipe
})
export class LogsComponent implements OnInit {
  
  public fechasGroup: FormGroup;

  constructor(private readonly spinnerService: SpinnerService, private readonly logService: LogsService, private readonly datePipe: DatePipe) { 
    
    this.fechasGroup = new FormGroup({
      fechaInicio: new FormControl(),
      fechaFin: new FormControl()
    });
  }
  
  async ngOnInit(): Promise<void> {
    this.fechasGroup.patchValue({
      fechaInicio: new Date,
      fechaFin: new Date
    });
  }

  async generarLogs() {
   
    let fechaInicio = this.datePipe.transform(this.fechasGroup.controls['fechaInicio'].value, 'yyyy-MM-dd 00:00:00')!;
    let fechaFin = this.datePipe.transform(this.fechasGroup.controls['fechaFin'].value, 'yyyy-MM-dd 23:59:59')!;
    
    let spinnerRef = this.spinnerService.start();

    await this.logService.getLogByFechas(fechaInicio, fechaFin)

    this.spinnerService.stop(spinnerRef);
  }
}